<script setup lang="ts">
  defineEmits(['reset-click']);
</script>

<template>
  <button
    class="reset-button"
    @click="$emit('reset-click')"
  >
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.2929 6.29289C16.6834 5.90237 17.3166 5.90237 17.7071 6.29289C18.0976 6.68342 18.0976 7.31658 17.7071 7.70711L13.4142 12L17.7071 16.2929C18.0976 16.6834 18.0976 17.3166 17.7071 17.7071C17.3166 18.0976 16.6834 18.0976 16.2929 17.7071L12 13.4142L7.70711 17.7071C7.31658 18.0976 6.68342 18.0976 6.29289 17.7071C5.90237 17.3166 5.90237 16.6834 6.29289 16.2929L10.5858 12L6.29289 7.70711C5.90237 7.31658 5.90237 6.68342 6.29289 6.29289C6.68342 5.90237 7.31658 5.90237 7.70711 6.29289L12 10.5858L16.2929 6.29289Z"
        fill="#2962F9"
      />
    </svg>
    <span>Очистить</span>
  </button>
</template>

<style lang="scss" scoped>
  $buttonColor: #2962f9;
  $hoverColor: #264eb1;

  .reset-button {
    font-family: $mainFont;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    position: absolute;
    display: flex;
    align-items: center;
    padding: 14px 15px;
    background-color: inherit;
    border: none;
    color: $buttonColor;
    transition: color 0.2s ease;
    top: 0;
    right: 0;
    z-index: 1;
    gap: 8px;
    svg {
      display: none;
      path {
        transition: fill 0.2s ease;
        fill: $buttonColor;
      }
    }
    @include big-tablet {
      position: relative;
      padding: 12px 0;
      margin: 0 16px;
      z-index: initial;
      svg {
        display: block;
      }
    }

    &:not(:disabled) {
      cursor: pointer;
    }
    @include big-tablet {
      @include hover {
        color: $hoverColor;

        svg {
          path {
            fill: $hoverColor;
          }
        }
      }
    }
  }
</style>
